var _class;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { selectNodeForward, selectParentNode } from 'prosemirror-commands';
import { NodeSelection, TextSelection } from 'prosemirror-state';
import { action } from '@ember/object';
import { dispatchImageUpdate } from '../../helpers/image';
import { BLOCK_TYPES, BLOCKS_WITH_STYLE } from '../../blocks/constants';
import { findSelectedSection, findSelectedTableCell, findSelectionAnchorNode, findSelectedCell, findSelectedCallout } from '@intercom/composer-ember/lib/helpers/selection';
let StylingCommands = (_class = class StylingCommands {
  constructor(editorView, config) {
    this.editorView = editorView;
    this.config = config;
  }
  updateImageDisplayWidth(newWidth) {
    if (!(this.isSelectedNodeType(BLOCK_TYPES.IMAGE) || this.isSelectedNodeType(BLOCK_TYPES.INLINE_IMAGE))) {
      return;
    }
    selectNodeForward(this.editorView.state, this.dispatch);
    let position = this.editorView.state.selection.from;
    let tr = this.editorView.state.tr;
    let node = this.currentNodeSelection.node;
    let newAttrs = Object.assign({}, node.attrs, {
      displayWidth: newWidth
    });
    tr.setNodeMarkup(position, undefined, newAttrs);
    tr.setSelection(NodeSelection.create(tr.doc, this.editorView.state.selection.from));
    this.dispatch(tr);
  }
  removeImageDisplayWidth() {
    if (!this.isSelectedNodeType(BLOCK_TYPES.IMAGE)) {
      return;
    }
    selectNodeForward(this.editorView.state, this.dispatch);
    let position = this.editorView.state.selection.from;
    let tr = this.editorView.state.tr;
    let node = this.currentNodeSelection.node;
    let newAttrs = Object.assign({}, node.attrs);
    delete newAttrs.displayWidth;
    tr.setNodeMarkup(position, undefined, newAttrs);
    this.dispatch(tr);
  }
  updateFontFamily(newFontFamily, preserveSelection = false) {
    this.updateFontAttributeOnNode({
      fontFamily: newFontFamily
    }, preserveSelection);
  }
  updateFontColor(newFontColor, preserveSelection = false) {
    this.updateFontAttributeOnNode({
      fontColor: newFontColor
    }, preserveSelection);
  }
  updateNodeHeight(newHeight) {
    let selectedNode = findSelectionAnchorNode(this.editorView.state);
    this.updateNodeAttributes(selectedNode, {
      height: newHeight
    });
  }
  updateBackgroundColor(newBackgroundColor) {
    if (!this.isSelectedNodeType(BLOCK_TYPES.BUTTON) && !this.isSelectedNodeType(BLOCK_TYPES.TABLE)) {
      return;
    }
    selectNodeForward(this.editorView.state, this.dispatch);
    let position = this.editorView.state.selection.from;
    this.updateBackgroundColorOnNode(newBackgroundColor, this.currentNodeSelection.node, position);
  }
  updateSectionBackgroundColor(newBackgroundColor) {
    let section = findSelectedSection(this.editorView.state);
    if (!section) {
      return;
    }
    this.updateBackgroundColorOnNode(newBackgroundColor, section.node, section.pos);
  }
  updateSectionPadding(newPadding) {
    let newPaddingValues = {
      paddingTop: newPadding,
      paddingBottom: newPadding,
      paddingLeft: newPadding,
      paddingRight: newPadding
    };
    let tableCell = findSelectedTableCell(this.editorView.state);
    let node = tableCell?.node;
    if (!tableCell) {
      return;
    }
    if (node?.isBlock) {
      let tr = this.editorView.state.tr;
      let newAttrs = Object.assign({}, node.attrs, newPaddingValues);
      tr.setNodeMarkup(tableCell.pos, undefined, newAttrs);
      this.dispatch(tr);
      dispatchImageUpdate(this.config, this.editorView.state.tr, this.dispatch);
    }
  }
  updateBlockPadding(newPadding) {
    selectNodeForward(this.editorView.state, this.dispatch);
    let node = this.currentNodeSelection.node;
    if (node?.isBlock) {
      this.updateNodeAttributes(node, newPadding);
    }
  }
  toggleButtonStyle() {
    if (this.isSelectedNodeType(BLOCK_TYPES.BUTTON)) {
      selectNodeForward(this.editorView.state, this.dispatch);
    }
    if (this.currentNodeSelection?.node) {
      let node = this.currentNodeSelection.node;
      let newButtonStyle = node.attrs.buttonStyle === 'solid' ? 'outline' : 'solid';
      this.updateNodeAttributes(node, {
        buttonStyle: newButtonStyle
      });
    }
  }
  updateBorderRadius(newBorderRadius) {
    if (this.isSelectedNodeType(BLOCK_TYPES.BUTTON) || this.isSelectedNodeType(BLOCK_TYPES.TABLE)) {
      selectNodeForward(this.editorView.state, this.dispatch);
    }
    if (this.currentNodeSelection?.node) {
      let node = this.currentNodeSelection.node;
      this.updateNodeAttributes(node, {
        borderRadius: newBorderRadius
      });
    }
  }
  updateTableCellBackgroundColor(newBackgroundColor) {
    let selectedTableCellRanges = this.editorView.state.selection.ranges;
    selectedTableCellRanges.forEach(selectionRange => {
      this.setSelection(selectionRange.$from.pos, selectionRange.$to.pos);
      let tableCell = findSelectedCell(this.editorView.state);
      if (!tableCell) {
        return;
      }
      this.updateBackgroundColorOnNode(newBackgroundColor, tableCell.node, tableCell.pos);
    });
  }
  updateCalloutColor(styleAttrs) {
    let callout = findSelectedCallout(this.editorView.state);
    if (!callout) {
      return;
    }
    this.updateNodeStyleAttributes(styleAttrs, callout.node, callout.pos);
  }
  dispatch(t) {
    this.editorView.dispatch(t);
  }

  //if the parent is a listItem, we traverse upward twice to reach the Unordered/orderedList.
  //1st call to `selectParentNode` will give the listItem, 2nd call to `selectParentNode` will give the actual list.
  getItemListNodeSelection() {
    selectParentNode(this.editorView.state, this.dispatch);
    selectParentNode(this.editorView.state, this.dispatch);
    return this.editorView.state.selection;
  }
  updateNodeAttributes(node, updatedAttributes) {
    let position = this.editorView.state.selection.from;
    let tr = this.editorView.state.tr;
    let newAttrs = Object.assign({}, node.attrs, updatedAttributes);
    tr.setNodeMarkup(position, undefined, newAttrs);
    tr.setSelection(NodeSelection.create(tr.doc, position));
    this.dispatch(tr);
  }
  updateBackgroundColorOnNode(newBackgroundColor, node, position) {
    if (node?.isBlock && BLOCKS_WITH_STYLE.includes(node?.type.name)) {
      let tr = this.editorView.state.tr;
      let newAttrs = Object.assign({}, node.attrs, {
        backgroundColor: newBackgroundColor
      });
      tr.setNodeMarkup(position, undefined, newAttrs);
      if (!node.attrs.container) {
        tr.setSelection(NodeSelection.create(tr.doc, position));
      }
      this.dispatch(tr);
    }
  }
  updateFontAttributeOnNode(fontAttrs, preserveSelection = false) {
    let currentSelection = this.editorView.state.selection;
    if (this.isSelectedNodeType(BLOCK_TYPES.BUTTON)) {
      selectNodeForward(this.editorView.state, this.dispatch);
    } else if (!(this.editorView.state.selection instanceof NodeSelection)) {
      selectParentNode(this.editorView.state, this.dispatch);
    }
    let node = this.currentNodeSelection.node;

    //list(ordered/unordered) in Prosemirror is represented as list=>listItem=>paragraph.
    //So we check here if the parent is listItem, the paragraph is a part of a list,
    if (this.editorView.state.selection.$anchor.parent?.type.name === 'listItem') {
      node = this.getItemListNodeSelection().node;
    }
    if (node?.isBlock && BLOCKS_WITH_STYLE.includes(node?.type.name)) {
      let tr = this.editorView.state.tr;
      let newAttrs = Object.assign({}, node.attrs, fontAttrs);
      tr.setNodeMarkup(this.editorView.state.selection.from, undefined, newAttrs);
      this.dispatch(tr);
    }
    if (preserveSelection) {
      this.setSelection(currentSelection.$anchor.pos, currentSelection.$head.pos);
    }
  }
  setSelection(anchor, head) {
    let anchorPos = this.editorView.state.doc.resolve(anchor);
    let headPos = this.editorView.state.doc.resolve(head);
    this.dispatch(this.editorView.state.tr.setSelection(new TextSelection(anchorPos, headPos)));
  }
  isSelectedNodeType(nodeTypeName) {
    return this.currentNodeSelection.$anchor.nodeAfter?.type.name === nodeTypeName;
  }
  get currentNodeSelection() {
    return this.editorView.state.selection;
  }
  updateNodeStyleAttributes(styleAttrs, node, position) {
    if (node?.isBlock && BLOCKS_WITH_STYLE.includes(node?.type.name)) {
      let tr = this.editorView.state.tr;
      let newAttrs = Object.assign({}, node.attrs, styleAttrs);
      tr.setNodeMarkup(position, undefined, newAttrs);
      this.dispatch(tr);
    }
  }
}, _applyDecoratedDescriptor(_class.prototype, "dispatch", [action], Object.getOwnPropertyDescriptor(_class.prototype, "dispatch"), _class.prototype), _class);
export { StylingCommands as default };